/**
 * Analytics event names for Umami.
 * Use these constants with useEvent / umami.track for consistent naming.
 */
export const ANALYTICS_EVENTS = {
  /** User clicked a navbar link. Payload: { section } */
  NAV_CLICK: "nav_click",
  /** User clicked a social link (LinkedIn/GitHub). Payload: { platform } */
  SOCIAL_CLICK: "social_click",
  /** User clicked a project card. Payload: { project: projectTitle } */
  PROJECT_CLICK: "project_click",
  /** User clicked "View Project" in the modal. Payload: { project: projectTitle } */
  VIEW_PROJECT_CLICK: "view_project_click",
  /** User successfully sent the contact form. No payload. */
  EMAIL_SENT: "email_sent",
  /** User clicked "Download Resume" in the hero. No payload. */
  RESUME_DOWNLOAD_CLICK: "resume_download_click",
};

/** Nav sections for nav_click events */
export const NAV_SECTIONS = {
  ABOUT: "about",
  EXPERIENCE: "experience",
  EDUCATION: "education",
  PROJECTS: "projects",
  SKILLS: "skills",
  CONTACT: "contact",
};

/** Social platforms for social_click events */
export const SOCIAL_PLATFORMS = {
  LINKEDIN: "linkedin",
  GITHUB: "github",
};
